import { ContentfulClient } from 'react-contentful';

export const contentfulClient = new ContentfulClient({
    accessToken: 'hhrcOW1bF__OPyGrBosF2r6vjMyU8L37reztOyv-XUw',
    space: 'tnt6tlkb785t',
});